/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Timing and pagination constants for ViewAppointments.
 * @module pages/viewAppointments/viewAppointmentsConstants
 */

/** Default page size for the appointments table. */
export const DEFAULT_RESULTS_LIMIT = 10;

/** Debounce delay before search triggers a refetch. */
export const SEARCH_DEBOUNCE_MS = 300;

/** Slide-up animation duration for success toasts. */
export const SUCCESS_ANIMATION_MS = 300;

/** How long success toasts remain visible before sliding away. */
export const SUCCESS_DISPLAY_MS = 3000;

/** React-select value container padding for main filter controls. */
export const SELECT_VALUE_PADDING = "10px 16px 10px 12px";

/** React-select value container padding for filter dropdown controls. */
export const FILTER_SELECT_VALUE_PADDING = "6px 12px";

/** Shared width for buyer/requirement select controls. */
export const SELECT_CONTROL_WIDTH = "220px";

/** Shared height for buyer/requirement select controls. */
export const SELECT_CONTROL_HEIGHT = "44px";

/** Height for filter dropdown select controls. */
export const FILTER_SELECT_CONTROL_HEIGHT = "36px";

/** Menu z-index for portal-mounted select menus. */
export const SELECT_MENU_Z_INDEX = 99999;

/** Menu z-index for in-panel filter selects. */
export const FILTER_SELECT_MENU_Z_INDEX = 9999;

/** i18n key reused across multiple select placeholders. */
export const COMMON_SELECT_PLACEHOLDER_KEY = "common.select";
